import { ENV } from './env';

const API_BASE_URL = ENV.apiHost;

export default API_BASE_URL;
